import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';

export const EditChildCorpDescription: React.FC = () => {
  return (
    <Copy variant="body">
      Any changes made on this page will only apply to this child account.
    </Copy>
  );
};
